import { routeService } from '@/services/routeService';
import { optimizePeriod } from '@/utils/domain/routeOptimizer';
import { log } from '@/utils/core/vueLogger.js';

// Route optimization adapter (#23500). The spec puts the calculation server-side, but no endpoint exists yet,
// so it runs in the front: OSRM travel-time matrix + the pure solver. This is the single place to swap for an
// API call later — callers only depend on optimizeRoute(problems, options) and the result shape of
// routeOptimizer.optimizePeriod().

const dayPoints = (day) => [day.startPoint, day.endPoint, ...day.items.map((item) => item.point)].filter((point) => point !== null && point !== undefined);

/**
 * @param {{days: object[], coordinates: number[][], stepMinutes: number}} problems  from agendaRouteSource.buildRouteProblems()
 * @param {{keepStart: boolean, keepEnd: boolean}} options      RG-11
 * @param {Set<string>} [kept]  unplaceable visits the user keeps on their current slot (RG-21)
 */
export async function optimizeRoute(problems, options, kept = new Set()) {
	const startedAt = performance.now();
	const durations = problems.coordinates.length >= 2 ? await routeService.getDurationMatrix(problems.coordinates, problems.days.map(dayPoints)) : [[0]];
	const result = optimizePeriod(problems.days, durations, options, { now: Date.now(), stepMinutes: problems.stepMinutes || 15, kept });
	log('info', 'RouteOptimizer', `Optimized ${problems.days.length} day(s), ${problems.coordinates.length} point(s) in ${Math.round(performance.now() - startedAt)} ms — travel ${result.travelBefore} → ${result.travelAfter} min`);
	return { ...result, durations };
}
